var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_7741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7667 7.25833L12.7417 3.23333C12.2733 2.76436 11.6378 2.50058 10.975 2.5H5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5V15C2.5 15.663 2.76339 16.2989 3.23223 16.7678C3.70107 17.2366 4.33696 17.5 5 17.5H15C15.663 17.5 16.2989 17.2366 16.7678 16.7678C17.2366 16.2989 17.5 15.663 17.5 15V9.025C17.4994 8.36218 17.2356 7.72672 16.7667 7.25833ZM8.33333 15.8333V14.1667H11.6667V15.8333H8.33333ZM15.8333 15C15.8333 15.221 15.7455 15.433 15.5893 15.5893C15.433 15.7455 15.221 15.8333 15 15.8333H13.3333V13.3333C13.3333 13.1123 13.2455 12.9004 13.0893 12.7441C12.933 12.5878 12.721 12.5 12.5 12.5H7.5C7.27899 12.5 7.06702 12.5878 6.91074 12.7441C6.75446 12.9004 6.66667 13.1123 6.66667 13.3333V15.8333H5C4.77899 15.8333 4.56702 15.7455 4.41074 15.5893C4.25446 15.433 4.16667 15.221 4.16667 15V5C4.16667 4.77899 4.25446 4.56702 4.41074 4.41074C4.56702 4.25446 4.77899 4.16667 5 4.16667H6.66667V8.33333C6.66667 8.55435 6.75446 8.76631 6.91074 8.92259C7.06702 9.07887 7.27899 9.16667 7.5 9.16667H10.8333C11.0543 9.16667 11.2663 9.07887 11.4226 8.92259C11.5789 8.76631 11.6667 8.55435 11.6667 8.33333C11.6667 8.11232 11.5789 7.90036 11.4226 7.74408C11.2663 7.5878 11.0543 7.5 10.8333 7.5H8.33333V4.16667H10.975C11.1956 4.16974 11.407 4.25606 11.5667 4.40833L15.5917 8.43333C15.6689 8.5112 15.73 8.60355 15.7715 8.70508C15.8129 8.80661 15.834 8.91533 15.8333 9.025V15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_7741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveOutline);
export default __webpack_public_path__ + "static/media/saveOutline.442111977d990e20c769acb3d13143c5.svg";
export { ForwardRef as ReactComponent };